/* eslint-disable no-else-return */
import filesize from 'filesize'

export function formatFileSize(data) {
  if (/^\d+$/.test(data)) {
    return filesize(data)
  } else {
    return ''
  }
}
